import { css } from "@emotion/react"

export const addressStyle = css`
	p {
		margin-bottom: 1rem;

		&:last-of-type {
			margin-bottom: 0;
		}
	}
`
